import { render, staticRenderFns } from "./MmplEditAbout.vue?vue&type=template&id=1397ba90&scoped=true&"
import script from "./MmplEditAbout.vue?vue&type=script&lang=js&"
export * from "./MmplEditAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1397ba90",
  null
  
)

export default component.exports